import Vue, { PropType } from 'vue';
import IconBase from '../icon';
import { IconProps, SVGJson } from '../utils/types';
import useSizeProps from '../utils/use-size-props';

const element: SVGJson = {"tag":"svg","attrs":{"fill":"none","viewBox":"0 0 24 24","width":"1em","height":"1em"},"children":[{"tag":"path","attrs":{"fill":"props.filledColor","d":"M11.0002 3.12602V1H13.0002V3.12602C14.7254 3.57006 16.0002 5.13616 16.0002 7C16.0002 8.22945 15.4452 9.32849 14.5748 10.0613L16.1274 23H7.87305L9.42569 10.0613C8.55527 9.32849 8.00022 8.22945 8.00022 7C8.00022 5.13616 9.27499 3.57006 11.0002 3.12602ZM11.334 10.9446L10.1274 21H13.873L12.6664 10.9446C12.4495 10.981 12.2269 11 12.0002 11C11.7735 11 11.5509 10.981 11.334 10.9446Z"}}]};

const Tower3Filled = Vue.extend<IconProps>({
  name: 'Tower3FilledIcon',
  functional: true,
  props: {
    size: {
      type: String,
    },
    onClick: {
      type: Function as PropType<IconProps['onClick']>,
    },
    fillColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeColor: {
      type: [String, Array] as PropType<IconProps['fillColor']>,
    },
    strokeWidth: {
      type: Number,
      default: 2
    }
  },
  render(createElement, context) {
    const { props, data } = context;
    const { size, ...otherProps } = props;

    const { className, style } = useSizeProps(size);
    const fullProps = {
      ...otherProps || {},
      id: 'tower-3-filled',
      icon: element,
      staticClass: className,
      style,
    };
    data.props = fullProps;
    return createElement(IconBase, data);
  },
});

export default Tower3Filled;
